import { Auth } from 'aws-amplify';

import { logError } from '../utils/sentryUtils';

let baseURL = '';

let { VITE_REACT_APP_BACKEND: apiBackend = '' } = import.meta.env;

apiBackend = apiBackend.trim();

if (apiBackend) {
    if (apiBackend.match(/^pr-\d+$/)) {
        // Handle new review environment pattern: pr-XXXX -> ecommerce-pr-XXXX
        baseURL = `https://ecommerce-${apiBackend}.k8s-prod.misfitsmarket.io`;
    } else {
        baseURL = `https://${apiBackend}-dev.misfitsmarket.com`;
    }
}

const defaultOptions = {
    headers: {
        'Content-Type': 'application/json',
    },
};

const mmFetch = async (url, options = {}) => {
    const headers = { ...defaultOptions.headers, ...options.headers };

    try {
        const session = await Auth.currentSession();
        const bearerToken = session?.getIdToken()?.getJwtToken();
        if (bearerToken && !headers.Authorization) {
            headers.Authorization = `Bearer ${bearerToken}`;
        }
    } catch (error) {
        logError(error);
        // Authorization header will not be included if session retrieval fails
    }

    const isFormDataBody = typeof FormData !== 'undefined' && options?.body instanceof FormData;
    if (isFormDataBody) {
        delete headers['Content-Type'];
    }

    return fetch(`${baseURL}/${url}`, { ...defaultOptions, ...options, headers });
};

export { mmFetch };
